import React from 'react';
import { View } from 'react-native-web';
import { cancel_str, Save_str } from '../../../utils/DictionaryManagementUtils';
import EditOrderButton from './EditOrderButton';

//= ========================================================================
const EditOrderPanelButton = ({
  onPressSave,
  onPressCancel,
  language,
}) => (
  <View style={{ flexDirection: 'row', justifyContent: 'end' }}>
    <EditOrderButton
      onPress={onPressCancel}
      language={language}
      text={cancel_str}
    />
    <EditOrderButton
      onPress={onPressSave}
      language={language}
      text={Save_str}
      backgroundColor
      textColor
    />

  </View>
);

export default EditOrderPanelButton;
